module.exports = __webpack_public_path__ + "img/pagination.10655c13.svg";